module.exports = __webpack_public_path__ + "static/GraphiQL-autocomplete-8fd9f4f4c31db490054be1c5e31a7ae2.png";